import { fetcher } from '@commenda/utils';
import { IIndirectTaxUpdateValidationStatusParams } from './types';

export async function updateIndirectTaxRegistrationValidationStatus(
  registrationId: string,
  corporationId: number,
  body: IIndirectTaxUpdateValidationStatusParams
): Promise<{ success: boolean; message?: string; error?: string }> {
  try {
    const response = await fetcher(
      `new-sales-tax/internal/registrations-v2/${registrationId}/validation-status`,
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update validation status',
      };
    }

    const data = await response.json();
    return { success: true, message: data.message };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to update validation status';
    return { success: false, error: errorMessage };
  }
}
